export const mappedAddressTypes = [
	{
		cdTipoLogradouro: 'ST',
		dsTipoLogradouro: ['SETOR'],
	},
	{
		cdTipoLogradouro: 'LRG',
		dsTipoLogradouro: ['LARGO'],
	},
	{
		cdTipoLogradouro: 'Q',
		dsTipoLogradouro: ['QUADRA'],
	},
	{
		cdTipoLogradouro: 'PSG',
		dsTipoLogradouro: ['PASSAGEM'],
	},
	{
		cdTipoLogradouro: 'AC',
		dsTipoLogradouro: ['ACESSO'],
	},
	{
		cdTipoLogradouro: 'AL',
		dsTipoLogradouro: ['ALAMEDA', 'AL'],
	},
	{
		cdTipoLogradouro: 'AV',
		dsTipoLogradouro: ['AVENIDA', 'AV'],
	},
	{
		cdTipoLogradouro: 'BC',
		dsTipoLogradouro: ['BECO'],
	},
	{
		cdTipoLogradouro: 'CIRC',
		dsTipoLogradouro: ['CIRCULAR'],
	},
	{
		cdTipoLogradouro: 'CJ',
		dsTipoLogradouro: ['CONJUNTO', 'CJ', 'CONJ'],
	},
	{
		cdTipoLogradouro: 'COND',
		dsTipoLogradouro: ['CONDOMINIO', 'COND'],
	},
	{
		cdTipoLogradouro: 'CPO',
		dsTipoLogradouro: ['CAMPO'],
	},
	{
		cdTipoLogradouro: 'EST',
		dsTipoLogradouro: ['ESTRADA', 'EST'],
	},
	{
		cdTipoLogradouro: 'ETA',
		dsTipoLogradouro: ['ESTACAO', 'EST'],
	},
	{
		cdTipoLogradouro: 'ETD',
		dsTipoLogradouro: ['ESTADIO'],
	},
	{
		cdTipoLogradouro: 'FAV',
		dsTipoLogradouro: ['FAVELA'],
	},
	{
		cdTipoLogradouro: 'FAZ',
		dsTipoLogradouro: ['FAZENDA'],
	},
	{
		cdTipoLogradouro: 'GAL',
		dsTipoLogradouro: ['GALERIA'],
	},
	{
		cdTipoLogradouro: 'GJA',
		dsTipoLogradouro: ['GRANJA'],
	},
	{
		cdTipoLogradouro: 'JD',
		dsTipoLogradouro: ['JARDIM'],
	},
	{
		cdTipoLogradouro: 'LD',
		dsTipoLogradouro: ['LADEIRA'],
	},
	{
		cdTipoLogradouro: 'LG',
		dsTipoLogradouro: ['LAGO', 'LG'],
	},
	{
		cdTipoLogradouro: 'LOT',
		dsTipoLogradouro: ['LOTEAMENTO', 'LOT'],
	},
	{
		cdTipoLogradouro: 'PC',
		dsTipoLogradouro: ['PRACA'],
	},
	{
		cdTipoLogradouro: 'PR',
		dsTipoLogradouro: ['PRAIA'],
	},
	{
		cdTipoLogradouro: 'PRQ',
		dsTipoLogradouro: ['PARQUE', 'PRQ', 'PQ'],
	},
	{
		cdTipoLogradouro: 'R',
		dsTipoLogradouro: ['RUA', 'R'],
	},
	{
		cdTipoLogradouro: 'ROD',
		dsTipoLogradouro: ['RODOVIA', 'ROD'],
	},
	{
		cdTipoLogradouro: 'SIT',
		dsTipoLogradouro: ['SITIO', 'SIT'],
	},
	{
		cdTipoLogradouro: 'TER',
		dsTipoLogradouro: ['TERMINAL', 'TERM', 'TER'],
	},
	{
		cdTipoLogradouro: 'TV',
		dsTipoLogradouro: ['TRAVESSA', 'TV'],
	},
	{
		cdTipoLogradouro: 'VD',
		dsTipoLogradouro: ['VIADUTO', 'VD'],
	},
	{
		cdTipoLogradouro: 'VL',
		dsTipoLogradouro: ['VILA', 'VL'],
	},
	{
		cdTipoLogradouro: 'VLE',
		dsTipoLogradouro: ['VALE'],
	},
	{
		cdTipoLogradouro: 'RET',
		dsTipoLogradouro: ['RETORNO'],
	},
	{
		cdTipoLogradouro: 'QD',
		dsTipoLogradouro: ['QUADRA'],
	},
];
